export const SERVER_RESPONSE_STATUS_OK = 'OK';
